import type { IConfigCatClient } from 'configcat-common'
import type { AppRuntimeConfig } from '~/utils/runtimeConfig'

let configCatClient: IConfigCatClient | null = null


const getConfigCat = async (config: AppRuntimeConfig) => {
  if (import.meta.server) {
    if (configCatClient) {
      return configCatClient
    }
    const configcat = await import("configcat-js-ssr")

    configCatClient = configcat.getClient(config.CONFIGCAT_KEY, configcat.PollingMode.AutoPoll,
      {pollIntervalSeconds: parseInt(config.CONFIGCAT_CACHE_TIMEOUT || '1800')})
    return configCatClient
  } else {
    throw new Error('ConfigCat is not available on the client side')
  }
}

export {
  getConfigCat
}
